var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents2" }, [
    _c("img", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isMobile,
          expression: "!isMobile"
        }
      ],
      staticClass: "bg",
      attrs: { src: "static/img/service/bg_white.png" }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isMobile,
            expression: "!isMobile"
          }
        ],
        staticClass: "contents"
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _c("div", { staticClass: "wrap" }, [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.gotoPage(
                        "https://www.carsuri.co.kr/intro?tab=2"
                      )
                    }
                  }
                },
                [_c("img", { attrs: { src: "static/img/service/btn.png" } })]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isMobile,
            expression: "isMobile"
          }
        ],
        staticClass: "contents"
      },
      [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _c("img", {
            attrs: { src: "static/img/mobile/service/background_gray_02.png" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "wrap" }, [
            _vm._m(5),
            _vm._v(" "),
            _vm._m(6),
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.gotoPage(
                        "https://www.carsuri.co.kr/intro?tab=2"
                      )
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "static/img/mobile/service/btn.png" }
                  })
                ]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: "static/img/service/site_service_img_02.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "static/img/icon_paper.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _vm._v("외장수리 "),
      _c("span", [_vm._v("비교 견적")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "body" }, [
      _c("p", [
        _vm._v(
          "\n            덴트, 범퍼 수리, 판금도색 등 외장 수리가 필요할 때"
        ),
        _c("br"),
        _vm._v(
          "\n            손상 부위의 사진 3장으로 내 주변 수리업체들의 견적서를"
        ),
        _c("br"),
        _vm._v("\n            실시간으로 받아보세요.\n          ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("사전견적 확인, 견적 비교 후 수리, 1년 품질보증서 까지!")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: "static/img/mobile/service/site_service_img_02_m.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "static/img/mobile/service/icon_paper.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _vm._v("수리 "),
      _c("span", [_vm._v("비교 견적")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "body" }, [
      _c("p", [
        _vm._v("\n            덴트, 범퍼 수리, 판금도색 등"),
        _c("br"),
        _vm._v("\n            외장 수리가 필요할 때 손상 부위의 사진 3장으로"),
        _c("br"),
        _vm._v("\n            내 주변 수리업체들의 견적서를"),
        _c("br"),
        _vm._v("\n            실시간으로 받아보세요.\n          ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n            사전견적 확인, 견적 비교 후 수리,"),
        _c("br"),
        _vm._v("\n            1년 품질보증서 까지!\n          ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36110339", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36110339","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/service/Contents2.vue
// module id = null
// module chunks = 